import React, { useState, createContext, useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

const AppointmentsContext = createContext();

const AppointmentsProvider = ({ children }) => {
  const { infos } = useSelector(state => state.appointments);
  const isSchedulerPage = useRouteMatch('/appointments/new');
  const [showSideMenu, setShowSideMenu] = useState(true);
  const [newApppointmentStep, setNewApppointmentStep] = useState(1);
  const [newAppointmentResult, setNewAppointmentResult] = useState(null);

  const handleShowSideMenu = useCallback(
    (show = null) =>
      setShowSideMenu(oldShowSideMenu =>
        typeof show === 'boolean' ? show : !oldShowSideMenu,
      ),
    [],
  );

  const getStatusStyle = useCallback((statusType = '') => {
    const className = statusType.toLowerCase().replace('_', '-');
    switch (statusType) {
      case 'ABSENT':
        return {
          label: 'Ausente',
          icon: 'cancel',
          className,
        };
      case 'INFO_ABSENCE':
        return {
          label: 'Ausência informada',
          icon: 'cancel',
          className,
        };
      case 'CANCELED':
        return {
          label: 'Cancelado',
          icon: 'cancel',
          className,
        };
      case 'CONCLUDED':
        return {
          label: 'Concluído',
          icon: 'check_circle',
          className,
        };
      case 'SCHEDULED':
      default:
        return {
          label: 'Agendado',
          icon: 'schedule',
          className,
        };
    }
  }, []);

  return (
    <AppointmentsContext.Provider
      value={{
        showSideMenu,
        handleShowSideMenu,
        isSchedulerPage,
        infos,
        newApppointmentStep,
        setNewApppointmentStep,
        newAppointmentResult,
        setNewAppointmentResult,
        getStatusStyle,
      }}
    >
      {children}
    </AppointmentsContext.Provider>
  );
};

function useAppointments() {
  const context = useContext(AppointmentsContext);
  if (!context) {
    throw new Error(
      'useAppointments must be used within an AppointmentsProvider',
    );
  }
  return context;
}

export { AppointmentsProvider, useAppointments };
